import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export const fetchTaskTE = <E = CF.API.ApiError>(
  { userId, appId, taskId }: CF.API.LabelerTask.FetchTaskRequest,
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.LabelerTask.FetchTasksResponse> =>
  fetchTE<CF.API.LabelerTask.FetchTasksResponse, E>(
    {
      path: `/api/_api/v2/users/${userId}/apps/${appId}/tasks/${taskId}`,
      method: 'GET',
    },
    onRejected,
  );
